module.exports = __webpack_public_path__ + "img/p2.e95d8f4e.jpg";